define((require) => {
    "use strict";

    const {CollectionView, ItemView} = require("marionette");
    const {template}                 = require("underscore");
    const CustomFontItemView         = require("editor/ui/settings/fonts/CustomFontItemView");
    const EditorEvents               = require("shared/services/EditorEvents");
    const LoggedInUserState          = require("shared/ui/user/LoggedInUserState");

    // We need to preserve the same `className` for both item views for the collection view
    // ordering to work correctly, see zbone/CollectionView.
    const ITEM_VIEW_CLASS_NAME = "custom-font-item-view";

    /**
     * The item view shown during upload.
     *
     * @class UploadProgressItemView
     */
    const UploadProgressItemView = ItemView.extend("UploadProgressItemView", {

        tagName: "li",

        className: ITEM_VIEW_CLASS_NAME,

        template: template(`<div class="progress-bar">`),

        modelEvents: {
            "change:progress": "_progressChangeHandler",
            "change:uploading": "_uploadChangeHandler"
        },

        ui: {
            progressBar: ".progress-bar"
        },

        onBeforeRender() {
            this.$el.addClass("uploading");
        },

        _uploadChangeHandler(model, uploading) {
            this.$el.toggleClass("uploading", uploading);

            if (uploading === undefined) {
                this.trigger("upload:complete");
            }
        },

        _progressChangeHandler(model, progress) {
            if (progress !== undefined) {
                const width = progress * 100;
                this.ui.progressBar.css("width", `${width}%`);
            }
        }

    });

    return CollectionView.extend("CustomFontCollectionView", {

        tagName: "ul",

        className: "custom-font-collection-view",

        itemEvents: {
            "upload:complete": "_itemViewUploadCompleteHandler"
        },

        getItemView(model) {
            return model.has("uploading") ? UploadProgressItemView : CustomFontItemView;
        },

        _itemViewUploadCompleteHandler(event, {model}) {
            this._triggerEditorEvent(model);
            // Once upload is complete, remove the `UploadProgressItemView` instance by removing the model from the collection.
            this.collection.remove(model);
            // Re-add it to proper render a new `CustomFontItemView` instance...
            this.collection.add(model);
        },

        /**
         * @private
         *
         * @param {CustomFontItemView} model - The font uploaded
         * Send an event to MixPanel when a Custom font is uploaded.
         */
        _triggerEditorEvent(model) {
            const user              = LoggedInUserState.get("user");
            const eventProperties   = {
                username:       user.get("username"),
                userId:         user.get("id"),
                fontId:         model.get("id"),
                fontName:       model.get("name"),
                fontType:       "custom",
                triggerOrigin:  "CustomFontsUploader"
            };

            EditorEvents.trigger(EditorEvents.constants.UPLOAD_FONT, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/CustomFontCollectionView.js